
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[servicesPages]",
      function () {
        return require("private-next-pages/services/[servicesPages].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[servicesPages]"])
      });
    }
  